import { render, staticRenderFns } from "./UnmatchedModal.vue?vue&type=template&id=19e35a4e&scoped=true&"
import script from "./UnmatchedModal.vue?vue&type=script&lang=js&"
export * from "./UnmatchedModal.vue?vue&type=script&lang=js&"
import style0 from "./UnmatchedModal.vue?vue&type=style&index=0&id=19e35a4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e35a4e",
  null
  
)

export default component.exports